import {HTTPError} from '@jetbrains/teamcity-ui/dist/services'
import type {SerializedError} from '@reduxjs/toolkit'
import type {FetchBaseQueryError} from '@reduxjs/toolkit/query'

export function extractError(
  error: SerializedError | FetchBaseQueryError | undefined,
): Error | string | null | undefined {
  if (error == null) {
    return null
  } else if ('status' in error) {
    if (typeof error.status === 'number' && typeof error.data === 'string') {
      return new HTTPError(error.data, error.status)
    }
    if (error.data instanceof Error || typeof error.data === 'string') {
      return error.data
    } else if ('error' in error) {
      return error.error
    } else {
      return null
    }
  } else {
    return error.message
  }
}

export function extractErrorMessage(
  error: SerializedError | FetchBaseQueryError | string | null | undefined,
): string | null | undefined {
  if (typeof error === 'string' || error == null) {
    return error
  }
  const extractedError = extractError(error)
  return typeof extractedError === 'string' ? extractedError : extractedError?.message
}

const unknownErrorMessage = 'Unknown error'

export const getExtractErrorMessage = (
  error: SerializedError | FetchBaseQueryError | string | null | undefined,
) => {
  try {
    if (error != null) {
      const extractedError = extractErrorMessage(error)

      if (typeof extractedError === 'string') {
        const errors = JSON.parse(extractedError).errors

        if (Array.isArray(errors)) {
          return errors.map(({message}) => message).join('\n')
        }

        return extractedError
      }
    }
  } catch (e) {
    return unknownErrorMessage
  }

  return unknownErrorMessage
}
